var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Renderer_offscreenShadowCanvas, _Renderer_offscreenShadowCtx, _Renderer_drawOffscreenCtxShadow, _Renderer_createOffscreenCtxShadows, _Renderer_drawOffscreenCtxShapeForShadow, _Renderer_clearOffscreenCtxShadowParams, _Renderer_drawTile, _Renderer_drawClosestLevelTilesInCurrentLevelTileArea, _Renderer_renderTilesList, _Renderer_drawDevDot, _Renderer_drawDevDot2, _Renderer_drawDevDot3, _Renderer_renderViewportArea, _Renderer_renderLQBG, _Renderer_drawTopEllipse, _Renderer_drawBottomEllipse, _Renderer_renderOptimizedShadow;
import { DISABLE_DRAW_TILES, DOUBLE_BUFFERING_ENABLED, IS_DEV_MODE_ENABLED, PER_LEVELS_MULTIPLIER, RENDER_NEXT_LEVEL_TILES, RENDER_OTHER_LEVEL_TILES, RENDER_PREV_LEVEL_TILES, SHADOWS_CTX_SIZE_MULTIPLIER, SHADOWS_FIGURE_INSET, TILE_SIZE, } from '../consts';
export class Renderer {
    constructor(ctx, visibleCtx, mainCanvas, shadowsCtx, spotlightCtx, viewport, images, placeholderURL, drawShadows, drawSpotlight, isDarkMode) {
        Object.defineProperty(this, "ctx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "visibleCtx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shadowsCtx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spotlightCtx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainCanvas", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "images", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "devRendersCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "placeholderImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "drawShadows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "drawSpotlight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDarkMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _Renderer_offscreenShadowCanvas.set(this, void 0);
        _Renderer_offscreenShadowCtx.set(this, void 0);
        _Renderer_drawOffscreenCtxShadow.set(this, (color, offsetX, offsetY, blur) => {
            const shadowMultiplier = (this.viewport.zoomPercentage / this.viewport.zoomPercentageMin) * this.viewport.devicePixelRatio;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowColor = color;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowOffsetX = offsetX * shadowMultiplier;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowOffsetY = offsetY * shadowMultiplier;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowBlur = blur * shadowMultiplier * 1;
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShapeForShadow, "f").call(this);
        });
        _Renderer_createOffscreenCtxShadows.set(this, () => {
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShadow, "f").call(this, 'rgba(0, 0, 0, 0.01)', 0, 129, 36);
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShadow, "f").call(this, 'rgba(0, 0, 0, 0.03)', 0, 82, 33);
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShadow, "f").call(this, 'rgba(0, 0, 0, 0.08)', 0, 46, 28);
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShadow, "f").call(this, 'rgba(0, 0, 0, 0.12)', 0, 21, 20);
            __classPrivateFieldGet(this, _Renderer_drawOffscreenCtxShadow, "f").call(this, 'rgba(0, 0, 0, 0.16)', 0, 6, 11);
            __classPrivateFieldGet(this, _Renderer_clearOffscreenCtxShadowParams, "f").call(this);
        });
        _Renderer_drawOffscreenCtxShapeForShadow.set(this, () => {
            const offscreenShadowCanvasWidthUnscaled = __classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").width / SHADOWS_CTX_SIZE_MULTIPLIER;
            const offscreenShadowCanvasHeightUnscaled = __classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").height / SHADOWS_CTX_SIZE_MULTIPLIER;
            const x = offscreenShadowCanvasWidthUnscaled * (SHADOWS_CTX_SIZE_MULTIPLIER / 2) - offscreenShadowCanvasWidthUnscaled / 2;
            const y = offscreenShadowCanvasHeightUnscaled * (SHADOWS_CTX_SIZE_MULTIPLIER / 2) - offscreenShadowCanvasHeightUnscaled / 2;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").beginPath();
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").rect(x, y, offscreenShadowCanvasWidthUnscaled, offscreenShadowCanvasHeightUnscaled);
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").fillStyle = this.isDarkMode ? '#3C3C3C' : '#C5C5C5';
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").closePath();
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").fill();
        });
        _Renderer_clearOffscreenCtxShadowParams.set(this, () => {
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowColor = 'transparent';
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowBlur = 0;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowOffsetX = 0;
            __classPrivateFieldGet(this, _Renderer_offscreenShadowCtx, "f").shadowOffsetY = 0;
        });
        _Renderer_drawTile.set(this, (posX, posY, nameX, nameY) => {
            if (this.images.loadedImages3D[this.viewport.level][nameY][nameX]) {
                const tileSizeX = this.images.loadedImages3D[this.viewport.level][nameY][nameX]?.naturalWidth || TILE_SIZE[0];
                const tileSizeY = this.images.loadedImages3D[this.viewport.level][nameY][nameX]?.naturalHeight || TILE_SIZE[1];
                this.ctx.drawImage(this.images.loadedImages3D[this.viewport.level][nameY][nameX], 0, 0, tileSizeX, tileSizeY, posX, posY, tileSizeX, tileSizeY);
            }
            else {
                if (RENDER_OTHER_LEVEL_TILES && !this.viewport.isZooming)
                    __classPrivateFieldGet(this, _Renderer_drawClosestLevelTilesInCurrentLevelTileArea, "f").call(this, posX, posY, nameX, nameY);
            }
        });
        _Renderer_drawClosestLevelTilesInCurrentLevelTileArea.set(this, (posX, posY, nameX, nameY) => {
            const nextLevel = this.viewport.level + 1;
            const nextLevelNameXFirst = nameX * PER_LEVELS_MULTIPLIER;
            const nextLevelNameYFirst = nameY * PER_LEVELS_MULTIPLIER;
            let img1 = null;
            let img2 = null;
            let img3 = null;
            let img4 = null;
            if (RENDER_NEXT_LEVEL_TILES) {
                img1 = this.images.loadedImages3D?.[nextLevel]?.[nextLevelNameYFirst]?.[nextLevelNameXFirst];
                img2 = this.images.loadedImages3D?.[nextLevel]?.[nextLevelNameYFirst]?.[nextLevelNameXFirst + 1];
                img3 = this.images.loadedImages3D?.[nextLevel]?.[nextLevelNameYFirst + 1]?.[nextLevelNameXFirst];
                img4 = this.images.loadedImages3D?.[nextLevel]?.[nextLevelNameYFirst + 1]?.[nextLevelNameXFirst + 1];
            }
            const halfX = TILE_SIZE[0] / 2;
            const halfY = TILE_SIZE[1] / 2;
            if (RENDER_NEXT_LEVEL_TILES && img1 && img2 && img3 && img4) {
                if (!DISABLE_DRAW_TILES) {
                    this.ctx.drawImage(img1, 0, 0, TILE_SIZE[0], TILE_SIZE[1], posX, posY, halfX, halfY);
                    this.ctx.drawImage(img2, 0, 0, TILE_SIZE[0], TILE_SIZE[1], posX + halfX, posY, halfY, halfY);
                    this.ctx.drawImage(img3, 0, 0, TILE_SIZE[0], TILE_SIZE[1], posX, posY + halfY, halfX, halfY);
                    this.ctx.drawImage(img4, 0, 0, TILE_SIZE[0], TILE_SIZE[1], posX + halfX, posY + halfY, halfX, halfY);
                }
            }
            else {
                if (RENDER_PREV_LEVEL_TILES) {
                    const prevLevel = this.viewport.level - 1;
                    const prevLevelNameX = ~~(nameX / PER_LEVELS_MULTIPLIER);
                    const prevLevelNameY = ~~(nameY / PER_LEVELS_MULTIPLIER);
                    const prevLevelOffsetX = nameX % PER_LEVELS_MULTIPLIER;
                    const prevLevelOffsetY = nameY % PER_LEVELS_MULTIPLIER;
                    const prevLevelTileImage = this.images.getLoadedImageByTilePosition(prevLevel, prevLevelNameX, prevLevelNameY);
                    if (prevLevelTileImage && !DISABLE_DRAW_TILES) {
                        this.ctx.drawImage(prevLevelTileImage, halfX * prevLevelOffsetX, halfY * prevLevelOffsetY, halfX, halfY, posX, posY, TILE_SIZE[0], TILE_SIZE[1]);
                    }
                }
            }
        });
        _Renderer_renderTilesList.set(this, () => {
            const pos = this.viewport.getPosInPx();
            const drawStartPosX = pos[0] - this.viewport.fullImageProps.width / 2;
            const drawStartPosY = pos[1] - this.viewport.fullImageProps.height / 2;
            for (let numX = this.viewport.visibleTiles.firstX; numX <= this.viewport.visibleTiles.lastX; numX++) {
                for (let numY = this.viewport.visibleTiles.firstY; numY <= this.viewport.visibleTiles.lastY; numY++) {
                    if (!DISABLE_DRAW_TILES) {
                        if (IS_DEV_MODE_ENABLED) {
                            __classPrivateFieldGet(this, _Renderer_drawTile, "f").call(this, drawStartPosX + numX * TILE_SIZE[0] + 2 * numX, drawStartPosY + numY * TILE_SIZE[1] + 2 * numY, numX, numY);
                        }
                        else {
                            __classPrivateFieldGet(this, _Renderer_drawTile, "f").call(this, drawStartPosX + numX * TILE_SIZE[0], drawStartPosY + numY * TILE_SIZE[1], numX, numY);
                        }
                    }
                }
            }
            if (IS_DEV_MODE_ENABLED) {
                __classPrivateFieldGet(this, _Renderer_drawDevDot, "f").call(this, pos[0], pos[1]);
                const ddd2x = this.viewport.VIEWPORT_SIZE.x + this.viewport.VIEWPORT_SIZE.w / 2;
                const ddd2y = this.viewport.VIEWPORT_SIZE.y + this.viewport.VIEWPORT_SIZE.h / 2;
                __classPrivateFieldGet(this, _Renderer_drawDevDot2, "f").call(this, ddd2x, ddd2y);
            }
        });
        _Renderer_drawDevDot.set(this, (x, y) => {
            this.ctx.fillStyle = 'rgba(255,0,0,1)';
            this.ctx.fillRect(x - 5, y - 5, 10, 10);
        });
        _Renderer_drawDevDot2.set(this, (x, y) => {
            this.ctx.fillStyle = 'rgba(0,255,0,1)';
            this.ctx.fillRect(x - 5, y - 5, 10, 10);
        });
        _Renderer_drawDevDot3.set(this, (x, y) => {
            this.ctx.fillStyle = 'rgba(0,0,255,1)';
            this.ctx.fillRect(x - 5, y - 5, 10, 10);
        });
        _Renderer_renderViewportArea.set(this, () => {
            this.ctx.fillStyle = 'rgba(0,0,100,0.95)';
            this.ctx.fillRect(this.viewport.VIEWPORT_SIZE.x, this.viewport.VIEWPORT_SIZE.y, this.viewport.VIEWPORT_SIZE.w, this.viewport.VIEWPORT_SIZE.h);
        });
        _Renderer_renderLQBG.set(this, () => {
            const pos = this.viewport.getPosInPx();
            const startPosX = pos[0] - this.viewport.fullImageProps.width / 2;
            const startPosY = pos[1] - this.viewport.fullImageProps.height / 2;
            const endPosX = pos[0] + this.viewport.fullImageProps.width / 2;
            const endPosY = pos[1] + this.viewport.fullImageProps.height / 2;
            if (IS_DEV_MODE_ENABLED) {
                __classPrivateFieldGet(this, _Renderer_drawDevDot3, "f").call(this, startPosX, startPosY);
                __classPrivateFieldGet(this, _Renderer_drawDevDot3, "f").call(this, endPosX, endPosY);
            }
            const bg = this.placeholderImage || this.images.getLoadedImageByTilePosition(0, 0, 0, true);
            if (bg)
                this.ctx.drawImage(bg, startPosX, startPosY, this.viewport.fullImageProps.width, this.viewport.fullImageProps.height);
        });
        _Renderer_drawTopEllipse.set(this, () => {
            const pos = this.viewport.getPosInPx();
            const startPosX = pos[0];
            const startPosY = pos[1] - this.viewport.fullImageProps.height / 2;
            this.spotlightCtx.strokeStyle = 'transparent';
            this.spotlightCtx.fillStyle = this.isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#DFDFDF';
            this.spotlightCtx.beginPath();
            this.spotlightCtx.ellipse(startPosX * this.viewport.scale, startPosY * this.viewport.scale, (this.viewport.fullImageProps.width / 2) * this.viewport.scale * 1.1, (this.viewport.fullImageProps.width / 2) * this.viewport.scale, 0, 0, 2 * Math.PI);
            this.spotlightCtx.fill();
            this.spotlightCtx.filter = 'none';
            this.spotlightCtx.fillStyle = 'transparent';
        });
        _Renderer_drawBottomEllipse.set(this, () => {
            const pos = this.viewport.getPosInPx();
            const startPosX = pos[0];
            const startPosY = pos[1] + this.viewport.fullImageProps.height / 2 + this.viewport.fullImageProps.height / 10;
            this.spotlightCtx.strokeStyle = 'transparent';
            this.spotlightCtx.fillStyle = this.isDarkMode ? 'rgba(255, 255, 255, 0.05)' : '#E4E4E4';
            this.spotlightCtx.beginPath();
            this.spotlightCtx.ellipse(startPosX * this.viewport.scale, startPosY * this.viewport.scale, (this.viewport.fullImageProps.width / 2) * this.viewport.scale, (this.viewport.fullImageProps.width / 2) * this.viewport.scale * 0.63, 0, 0, 2 * Math.PI);
            this.spotlightCtx.fill();
            this.spotlightCtx.filter = 'none';
            this.spotlightCtx.fillStyle = 'transparent';
        });
        _Renderer_renderOptimizedShadow.set(this, () => {
            const pos = this.viewport.getPosInPx();
            const fullImagePropsWidthScaled = this.viewport.fullImageProps.width * SHADOWS_CTX_SIZE_MULTIPLIER;
            const fullImagePropsHeightScaled = this.viewport.fullImageProps.height * SHADOWS_CTX_SIZE_MULTIPLIER;
            const dx = pos[0] - fullImagePropsWidthScaled / 2 + SHADOWS_FIGURE_INSET;
            const dy = pos[1] - fullImagePropsHeightScaled / 2 + SHADOWS_FIGURE_INSET;
            const dw = fullImagePropsWidthScaled - SHADOWS_FIGURE_INSET * 2;
            const dh = fullImagePropsHeightScaled - SHADOWS_FIGURE_INSET * 2;
            if (IS_DEV_MODE_ENABLED) {
                __classPrivateFieldGet(this, _Renderer_drawDevDot3, "f").call(this, dx, dy);
                __classPrivateFieldGet(this, _Renderer_drawDevDot3, "f").call(this, dw, dh);
            }
            this.ctx.drawImage(__classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f"), dx, dy, dw, dh);
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                requestAnimationFrame(() => {
                    this.ctx.clearRect(0, 0, this.viewport.VIEWPORT_SIZE.w, this.viewport.VIEWPORT_SIZE.h);
                    this.ctx.resetTransform();
                    this.ctx.scale(this.viewport.scale, this.viewport.scale);
                    if (this.drawShadows) {
                        __classPrivateFieldGet(this, _Renderer_renderOptimizedShadow, "f").call(this);
                    }
                    __classPrivateFieldGet(this, _Renderer_renderLQBG, "f").call(this);
                    if (IS_DEV_MODE_ENABLED)
                        __classPrivateFieldGet(this, _Renderer_renderViewportArea, "f").call(this);
                    __classPrivateFieldGet(this, _Renderer_renderTilesList, "f").call(this);
                    if (IS_DEV_MODE_ENABLED) {
                        this.devRendersCount++;
                        const pointerPositionScaled = this.viewport.getPointerPositionScaled();
                        __classPrivateFieldGet(this, _Renderer_drawDevDot3, "f").call(this, pointerPositionScaled[0], pointerPositionScaled[1]);
                    }
                    if (DOUBLE_BUFFERING_ENABLED) {
                        requestAnimationFrame(() => {
                            this.visibleCtx.clearRect(0, 0, this.viewport.VIEWPORT_SIZE.w, this.viewport.VIEWPORT_SIZE.h);
                            this.visibleCtx.drawImage(this.mainCanvas, 0, 0);
                        });
                    }
                    this.shadowsCtx.clearRect(0, 0, this.viewport.VIEWPORT_SIZE.w * this.viewport.devicePixelRatio * 2, this.viewport.VIEWPORT_SIZE.h * this.viewport.devicePixelRatio * 2);
                    this.shadowsCtx.resetTransform();
                    this.spotlightCtx.clearRect(0, 0, this.viewport.VIEWPORT_SIZE.w * this.viewport.devicePixelRatio * 2, this.viewport.VIEWPORT_SIZE.h * this.viewport.devicePixelRatio * 2);
                    this.spotlightCtx.resetTransform();
                    if (this.drawSpotlight) {
                        __classPrivateFieldGet(this, _Renderer_drawTopEllipse, "f").call(this);
                        __classPrivateFieldGet(this, _Renderer_drawBottomEllipse, "f").call(this);
                    }
                });
            }
        });
        this.ctx = ctx;
        this.visibleCtx = visibleCtx;
        this.shadowsCtx = shadowsCtx;
        this.spotlightCtx = spotlightCtx;
        this.mainCanvas = mainCanvas;
        this.viewport = viewport;
        this.images = images;
        this.drawShadows = drawShadows || false;
        this.drawSpotlight = drawSpotlight || false;
        this.isDarkMode = isDarkMode || false;
        if (placeholderURL) {
            this.placeholderImage = new Image();
            this.placeholderImage.src = placeholderURL;
        }
        __classPrivateFieldSet(this, _Renderer_offscreenShadowCanvas, document.createElement('canvas'), "f");
        __classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").width = Math.min(this.mainCanvas.width, this.mainCanvas.height) / 2;
        __classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").height =
            (__classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").width * this.viewport.fullImageProps.height) / this.viewport.fullImageProps.width;
        __classPrivateFieldSet(this, _Renderer_offscreenShadowCtx, __classPrivateFieldGet(this, _Renderer_offscreenShadowCanvas, "f").getContext('2d'), "f");
        __classPrivateFieldGet(this, _Renderer_createOffscreenCtxShadows, "f").call(this);
    }
}
_Renderer_offscreenShadowCanvas = new WeakMap(), _Renderer_offscreenShadowCtx = new WeakMap(), _Renderer_drawOffscreenCtxShadow = new WeakMap(), _Renderer_createOffscreenCtxShadows = new WeakMap(), _Renderer_drawOffscreenCtxShapeForShadow = new WeakMap(), _Renderer_clearOffscreenCtxShadowParams = new WeakMap(), _Renderer_drawTile = new WeakMap(), _Renderer_drawClosestLevelTilesInCurrentLevelTileArea = new WeakMap(), _Renderer_renderTilesList = new WeakMap(), _Renderer_drawDevDot = new WeakMap(), _Renderer_drawDevDot2 = new WeakMap(), _Renderer_drawDevDot3 = new WeakMap(), _Renderer_renderViewportArea = new WeakMap(), _Renderer_renderLQBG = new WeakMap(), _Renderer_drawTopEllipse = new WeakMap(), _Renderer_drawBottomEllipse = new WeakMap(), _Renderer_renderOptimizedShadow = new WeakMap();
